import React from 'react';
import './ProductImage.css';

/**
 * A component for displaying product images from the backend
 * 
 * This component simply uses the imageUrl property from product objects
 * and ensures images cover their container while maintaining aspect ratio
 * 
 * @param {Object} props Component props
 * @param {Object} props.product The product object containing imageUrl
 * @param {string} props.className Optional class name for styling the image container
 * @param {string} props.alt Optional alt text, defaults to product name
 * @returns {JSX.Element} Image component
 */
function ProductImage({ product, className = '', alt = '' }) {
  if (!product || !product.imageUrl) {
    return <div className={`product-image-wrapper ${className} empty-image`}></div>;
  }
  
  // Alt text fallback
  const altText = alt || product.name || "Product";
  
  return (
    <div className={`product-image-wrapper ${className}`}>
      <img 
        src={product.imageUrl}
        alt={altText}
        className="product-image-element"
      />
    </div>
  );
}

export default ProductImage;